/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_TitleInputs */

const en_mk_sec_pg_ledger_title = /** @type {(inputs: Mk_Sec_Pg_Ledger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running, and not running`)
};

const id_mk_sec_pg_ledger_title = /** @type {(inputs: Mk_Sec_Pg_Ledger_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah berjalan, dan belum`)
};

/**
* | output |
* | --- |
* | "Running, and not running" |
*
* @param {Mk_Sec_Pg_Ledger_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_title = /** @type {((inputs?: Mk_Sec_Pg_Ledger_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_title(inputs)
	return en_mk_sec_pg_ledger_title(inputs)
});